import React from 'react';
import PropTypes from 'prop-types';
import { View, Text } from 'react-native';

import styles from './Styles';
import { Heading, HeadingTypes } from '../../components';

const PrivacyEmptyList = ({
    t,
    listType,
    isLoading,
    invertColours,
}) => {
    let title = '';
    if (listType === 'whitelist') {
        title = t('noWorkoutPartnersHeader');
    } else if (listType === 'blacklist') {
        title = t('noBlockedWorkoutPartnersHeader');
    } else if (listType === 'searchlist') {
        title = t('noSearchWorkoutPartnersHeader');
    }

    if (!isLoading) {
        return (
            <View style={styles.headingContainer}>
                <Heading
                    title={title}
                    headerType={HeadingTypes.HEADING_ONE}
                    style={invertColours ? styles.invertedHeader : styles.header}
                />
            </View>
        );
    }

    return null;
}

PrivacyEmptyList.propTypes = {
    t: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    listType: PropTypes.oneOf(['whitelist', 'blacklist', 'searchlist']).isRequired,
};

export default PrivacyEmptyList;
